import * as React from "react";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import BOMain from "./components/main/BOMain";
import { ApolloProvider } from "react-apollo";
import { apolloClient } from "app/utils/graphQlClients";
import oktaClient from "./utils/oktaClient";
import moment from "moment";

import "./BackOffice.css";

const browserHistory = createBrowserHistory();

type State = {
  checkingAuth: boolean;
  tokenTimestamp: moment.Moment;
};

class BackOffice extends React.Component<any, State> {
  state = {
    checkingAuth: false,
    tokenTimestamp: moment()
  };
  listenerCleanup = function() {};

  continueToSavedLocation() {
    const href = localStorage.getItem("location");
    localStorage.removeItem("location");
    if (href) {
      browserHistory.push(href);
    }
  }

  redirectToLogin() {
    localStorage.setItem("location", window.location.pathname);
    window.location.href = "/login.html";
  }

  checkAuth() {
    this.setState({ checkingAuth: true });

    oktaClient
      .obtainValidToken()
      .then(() => {
        this.setState({ checkingAuth: false, tokenTimestamp: moment() });
        this.continueToSavedLocation();
      })
      .catch(() => {
        this.redirectToLogin();
      });
  }

  componentDidMount() {
    this.listenerCleanup = browserHistory.listen(() => {
      if (
        !browserHistory.location.pathname.includes("/login") &&
        this.state.tokenTimestamp.clone().add(10, "minutes") < moment()
      )
        this.checkAuth();
    });
    this.checkAuth();
  }

  componentWillUnmount() {
    this.listenerCleanup();
  }

  render() {
    if (this.state.checkingAuth) {
      return <h2>Checking authentication...</h2>;
    } else {
      return (
        <ApolloProvider client={apolloClient}>
          <Router history={browserHistory}>
            <BOMain />
          </Router>
        </ApolloProvider>
      );
    }
  }
}

export default BackOffice;
